<template>
    <client-page class="app--main">
        <!-- 메인 비주얼 -->
        <main-visual />

        <!-- 슬라이드 -->
        <main-slides />

        <!-- 파트너 가입 절차 -->
        <main-membership />

        <!-- 당신의 브랜드를 위한 맞춤 건강식품 생산 -->
        <main-producing />

        <!-- 협력 파트너사 -->
        <main-partners />

        <!-- 기술력 축적 및 신제품 출시 -->
        <main-products />

        <!-- 인증마크 -->
        <main-marks />

        <!-- 파트너 모집 -->
        <main-recruitment />

        <!-- 메인 비주얼 -->
        <!-- <main-visual code="main-visual" class="d-none d-md-block" />
        <main-visual code="main-visual-mo" class="d-md-none" /> -->

        <!-- <main-displays code="section1">
            <template #tit> 이달의 <span class="primary--text">핫딜 상품!</span> </template>
            <template #txt> 오늘 리본바이옴이 엄선한 가장 HOT한 상품! </template>
        </main-displays> -->

        <!-- 배너 -->
        <!-- <main-banner code="main-banner" class="d-none d-md-block" />
        <main-banner code="main-banner-mo" class="d-md-none" /> -->

        <!-- <main-displays code="section2">
            <template #tit> 쇼핑의 재미 <span class="primary--text">생활의 발견!</span> </template>
            <template #txt> 오늘 리본바이옴이 엄선한 가장 HOT한 상품! </template>
        </main-displays> -->

        <!-- <main-displays code="section3" class="pt-0">
            <template #tit> MD <span class="primary--text">추천 상품!</span> </template>
            <template #txt> 오늘 리본바이옴이 엄선한 가장 HOT한 상품! </template>
        </main-displays> -->

        <!-- <main-displays code="section4" class="pt-0">
            <template #tit> 카테고리 <span class="primary--text">추천 상품!</span> </template>
            <template #txt> 오늘 리본바이옴이 엄선한 가장 HOT한 상품! </template>
        </main-displays> -->

        <popup-layer v-for="popup in popups" :key="popup._id" :popup="popup"></popup-layer>
    </client-page>
</template>

<script>
import ClientPage from "@/components/client/templates/client-page.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import MainVisual from "@/components/client/main/main-visual.vue";
import MainBanner from "@/components/client/main/main-banner.vue";
import MainDisplays from "@/components/client/main/main-displays.vue";
import MainMembership from "@/components/client/main/main-membership.vue";
import MainProducing from "@/components/client/main/main-producing.vue";
import MainPartners from "@/components/client/main/main-partners.vue";
import MainProducts from "@/components/client/main/main-products.vue";
import MainMarks from "@/components/client/main/main-marks.vue";
import MainSection from "@/components/client/inc/main-section.vue";
import MainRecruitment from "@/components/client/main/main-recruitment.vue";
import MainSlides from "@/components/client/main/main-slides.vue";

export default {
    components: {
        ClientPage,
        PopupLayer,
        MainVisual,
        MainBanner,
        MainDisplays,
        MainMembership,
        MainProducing,
        MainPartners,
        MainProducts,
        MainMarks,
        MainSection,
        MainRecruitment,
        MainSlides,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data: () => {
        return {
            popups: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                await this.getPopups();
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
                else alert(error.message);
            }
        },

        getPopups() {
            return new Promise(async (resolve, reject) => {
                try {
                    var res = await this.$http.get("/api/v1/popups");
                    this.popups = res.data.popups;
                    resolve();
                } catch (error) {
                    reject(error);
                }
            });
        },
    },
};
</script>
